<template>
  <div class="content ht-100v pd-0">
    <main-header txt="ЗХУТ Дашбоард"> </main-header>
    <div class="content-body">
      <div class="container pd-0-f">
        <div class="row row-xs">
          <penalty-paid-data></penalty-paid-data>

          <div class="col-lg-4 mg-t-10">
            <penalty-group-by-type></penalty-group-by-type>

            <vehicle-count></vehicle-count>

            <div class="card mg-t-20" v-if="restrictedDaysData.rdy">
              <div class="card-header d-flex justify-content-between">
                <h6 class="mg-b-0">Дугаарын хязгаарлалт зөрчсөн</h6>
                <nav class="nav nav-row-xs align-items-center">
                  <a
                    @click="
                      restrictedDaysData.params.mode = 2;
                      loadHyazgaarlalt();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData.params.mode == 2 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >1W</a
                  >
                  <a
                    @click="
                      restrictedDaysData.params.mode = 3;
                      loadHyazgaarlalt();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData.params.mode == 3 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >1M</a
                  >
                  <a
                    @click="
                      restrictedDaysData.params.mode = 4;
                      loadHyazgaarlalt();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData.params.mode == 4 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >1Y</a
                  >
                </nav>
              </div>
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <div
                    v-for="(d, i) in restrictedDaysData.data.list"
                    :key="i"
                    class="profile-skillset flex-fill"
                  >
                    <h5>
                      <a class="link-01">{{ d.count>=1000?( (d.count/1000).toFixed(1)+'K'):Number(d.count).toLocaleString() }}</a>
                    </h5>
                    <label v-show="d.day == 1">Даваа</label>
                    <label v-show="d.day == 2">Мягмар</label>
                    <label v-show="d.day == 3">Лхагва</label>
                    <label v-show="d.day == 4">Пүрэв</label>
                    <label v-show="d.day == 5">Баасан</label>
                  </div>
                </div>
                <div>
                  <apexchart
                    type="bar"
                    height="250"
                    :options="chartDaysOptions"
                    :series="seriesDays"
                    :key="chartDaysOptionsKey"
                  ></apexchart>
                </div>

                <div class="d-flex align-items-center text-center">

                  <div @click="restrictedDaysData.params.distinct=!restrictedDaysData.params.distinct; loadHyazgaarlalt()" role="switch" :class="`el-switch ${restrictedDaysData.params.distinct?'is-checked':''}`" >
                    <span :class="`el-switch__label el-switch__label--left ${!restrictedDaysData.params.distinct?'is-active':''}`"><!----><span aria-hidden="true">Давхцалтай</span></span>
                    <span class="el-switch__core" style="width: 40px;"></span>
                    <span :class="`el-switch__label el-switch__label--right ${restrictedDaysData.params.distinct?'is-active':''}`"><!----><span>Давхцалгүй</span></span>
                  </div>

                  <!-- <Switch
  v-model="restrictedDaysData.params.distinct"
  active-text="Давхцхлгүй"
  inactive-text="Давхцалтай">
</Switch> -->
                  <div
                    class="profile-skillset flex-fill mg-l-auto"
                  >
                    <h5>
                      <a class="link-01">{{ Number((restrictedDaysData.data.list).reduce((sum, { count }) => sum + count, 0)).toLocaleString() }}</a>
                    </h5>
                    <label>Нийт</label>
                  </div>
                </div>

                <div class="text-center mg-t-10">
                  <a @click="$router.push({name: 'penaltyreportPlates'})" class="btn btn-secondary btn-xs">
                    Тайлан
                  </a>
                </div>
              </div>
              <div class="card-footer tx-11 tx-color-03 d-flex">
                <div>
                  Хамрах хугацаа:
                  {{
                    restrictedDaysData.data.processed.startDate
                      | moment("YYYY.MM.DD")
                  }}
                  -
                  {{
                    restrictedDaysData.data.processed.endDate
                      | moment("YYYY.MM.DD")
                  }}<br />
                  Боловсруулсан:
                  {{ restrictedDaysData.data.processed.time.toFixed(2) }}сек
                </div>
                <div class="mg-l-auto">
        <a @click="filterDateObj.mdl= true;" class="btn btn-primary">
          <feather type="filter"></feather>
          Огноо
        </a>
      </div>
              </div>
            </div>
          </div>

          <div class="col-lg-8 mg-t-10">
            <div class="col-12 pd-0">
              <div class="row no-gutter">
                <div class="col-lg-6 pd-t-0">
                  <terminals bd="" mgt=""></terminals>
                </div>
                <div class="col-lg-6 pd-t-0">
                  <accident bd="" mgt=""></accident>
                </div>
              </div>
            </div>

            <map-asset></map-asset>

            <div class="card mg-t-20" v-if="restrictedDaysData2.rdy">
              <div class="card-header d-flex justify-content-between">
                <h6 class="mg-b-0">Ачилтын мэдээ өдрөөр</h6>
                <nav class="nav nav-row-xs align-items-center">
                  <a
                    @click="
                      restrictedDaysData2.params.mode = 2;
                      loadHyazgaarlalt2();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData2.params.mode == 2 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >1W</a
                  >
                  <a
                    @click="
                      restrictedDaysData2.params.mode = 3;
                      loadHyazgaarlalt2();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData2.params.mode == 3 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >1M</a
                  >
                  <a
                    @click="
                      restrictedDaysData2.params.mode = 4;
                      loadHyazgaarlalt2();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData2.params.mode == 4 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >1Y</a
                  >
                </nav>
              </div>
              <div class="card-body">
                <div class="d-flex align-items-center">
                  <div
                    v-for="(d, i) in restrictedDaysData2.data.list"
                    :key="i"
                    class="profile-skillset flex-fill"
                  >
                    <h5>
                      <a class="link-01">{{ d.count>=1000?( (d.count/1000).toFixed(1)+'K'):Number(d.count).toLocaleString() }}</a>
                    </h5>
                    <label>{{ d.dayText }}</label>
                  </div>

                  <div
                    class="profile-skillset flex-fill"
                  >
                    <h5>
                      <a class="link-01">{{ Number((restrictedDaysData2.data.list).reduce((sum, { count }) => sum + count, 0)).toLocaleString() }}</a>
                    </h5>
                    <label>Нийт</label>
                  </div>
                </div>
                <div>
                  <apexchart
                    type="bar"
                    height="250"
                    :options="chartDaysOptions2"
                    :series="seriesDays2"
                    :key="chartDaysOptionsKey2"
                  ></apexchart>
                </div>
              </div>
              <div class="card-footer tx-11 tx-color-03 d-flex">
                <div>
                  Хамрах хугацаа:
                  {{
                    restrictedDaysData2.data.processed.startDate
                      | moment("YYYY.MM.DD")
                  }}
                  -
                  {{
                    restrictedDaysData2.data.processed.endDate
                      | moment("YYYY.MM.DD")
                  }}<br />
                  Боловсруулсан:
                  {{ restrictedDaysData2.data.processed.time.toFixed(2) }}сек
                </div>
                <div class="mg-l-auto">
                  <a @click="filterDateObj2.mdl= true;" class="btn btn-primary">
                    <feather type="filter"></feather>
                    Огноо
                  </a>
                </div>
              </div>
            </div>

            
          </div>
        </div>
      </div>
    </div>
    <filter-date @do-search="doSearch" :mdl="filterDateObj.mdl" @on-hide="filterDateObj.mdl= false"></filter-date>
    <filter-date @do-search="doSearch2" :mdl="filterDateObj2.mdl" @on-hide="filterDateObj2.mdl= false"></filter-date>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import { DatePicker } from "element-ui";
import VueApexCharts from "vue-apexcharts";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
//import mapAsset from "@/views/apps/penalty/components/mapAsset.vue";

const moment = require("moment");
import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import { Switch } from "element-ui";

export default {
  components: {
    apexchart: VueApexCharts,
    Switch,
    DatePicker,
    //mapAsset,
    filterDate: () => ({
      component: import("@/views/apps/penalty/components/filterDate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),

    mainHeader: () => ({
      component: import("@/views/apps/penalty/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    penaltyGroupByType: () => ({
      component: import(
        "@/views/apps/penalty/components/penaltyGroupByType.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    penaltyPaidData: () => ({
      component: import("@/views/apps/penalty/components/penaltyPaidData.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    mapAsset: () => ({
      component: import("@/views/apps/penalty/components/mapAsset.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    terminals: () => ({
      component: import("@/views/apps/penalty/components/terminals.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    accident: () => ({
      component: import("@/views/apps/penalty/components/accident.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    vehicleCount: () => ({
      component: import("@/views/apps/penalty/components/vehicleCount.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      filterDateObj: {
        mdl: false,
        d1: null,
        d2: null
      },
      filterDateObj2: {
        mdl: false,
        d1: null,
        d2: null
      },

      chartDaysOptionsKey: 0,
      chartDaysOptionsKey2: 0,
      seriesDays: [
        {
          name: "%",
          data: [],
        },
      ],

      seriesDays2: [
        {
          name: "%",
          data: [],
        },
      ],
      chartDaysOptions: {
        chart: {
          height: 150,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
      },

      chartDaysOptions2: {
        chart: {
          height: 150,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
        },
      },

      mapDate: null,
      restrictedDaysData: {
        rdy: false,
        params: {
          mode: 2,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          distinct: false,
        },
        data: {
          list: [],
        },
      },
      tovchoods: [],
      colors: ["green", "primary", "orange"],

      restrictedDaysData2: {
        rdy: false,
        params: {
          mode: 2,
          startDate: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: moment().format("YYYY-MM-DD"),
          distinct: false,
        },
        data: {
          list: [],
        },
      },
    };
  },
  mounted() {
    this.loadHyazgaarlalt();
    this.loadHyazgaarlalt2();
    this.loadTovchood();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },

    //
    doSearch(e){
      this.restrictedDaysData.params.startDate= e.d1;
      this.restrictedDaysData.params.endDate= e.d2;
      this.restrictedDaysData.params.mode= 0;
      this.loadHyazgaarlalt();
    },

    doSearch2(e){
      this.restrictedDaysData2.params.startDate= e.d1;
      this.restrictedDaysData2.params.endDate= e.d2;
      this.restrictedDaysData2.params.mode= 0;
      this.loadHyazgaarlalt2();
    },
    loadHyazgaarlalt() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/hzbhLimitedPlateNo" },
        params: {
          mode: this.restrictedDaysData.params.mode,
          startDate: this.restrictedDaysData.params.startDate,
          endDate: this.restrictedDaysData.params.endDate,
          distinct: this.restrictedDaysData.params.distinct,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.restrictedDaysData.data = res.data;
          this.seriesDays[0].data = res.data.list.map((x) => {
            return x.count;
          });
          this.chartDaysOptions.xaxis.categories = res.data.list.map((x) => {
            return x.dayText;
          });
          this.chartDaysOptionsKey++;
          this.restrictedDaysData.rdy = true;
        }
      });
    },

    loadHyazgaarlalt2() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/PenaltyByAchilt" },
        params: {
          mode: this.restrictedDaysData2.params.mode,
          startDate: this.restrictedDaysData2.params.startDate,
          endDate: this.restrictedDaysData2.params.endDate,
          distinct: this.restrictedDaysData2.params.distinct,
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.restrictedDaysData2.data = res.data;
          this.seriesDays2[0].data = res.data.list.map((x) => {
            return x.count;
          });
          this.chartDaysOptions2.xaxis.categories = res.data.list.map((x) => {
            return x.dayText;
          });
          this.chartDaysOptionsKey2++;
          this.restrictedDaysData2.rdy = true;
        }
      });
    },
    loadTovchood() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "TrafficData/hzbhEnteredToUbVehicles" },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.tovchoods = res.data.list1;
        }
      });
    },
  },
};
</script>
